import { useRefs } from "../framework";
import { lenis } from "./lenis";

function toggle(button, toOpen) {
  const contentId = button.getAttribute("aria-controls");
  const content = document.getElementById(contentId);

  button.setAttribute("aria-expanded", toOpen);
  content.classList.toggle("grid-rows-[1fr]", toOpen);
  content.classList.toggle("grid-rows-[0fr]", !toOpen);
  content.classList.toggle("opacity-100", toOpen);
  content.classList.toggle("opacity-0", !toOpen);

  button.parentElement.classList.toggle("opacity-50", !toOpen);
  button.parentElement.classList.toggle("opacity-100", toOpen);
}

export default (ref) => {
  if (!ref.scrollAccordion) return;

  const instances = ref.scrollAccordion.map((element) => {
    const { items } = useRefs({
      root: element,
      namespaced: true,
      asArray: true,
    });

    const itemsWithButtons = items.map((item) => {
      return {
        li: item,
        button: item.querySelector("button"),
      };
    });

    return { parent: element, items: itemsWithButtons };
  });

  function openTheItemClosestToTheCenter() {
    instances.forEach((instance) => {
      const { top, bottom } = instance.parent.getBoundingClientRect();

      if (top > window.innerHeight || bottom < 0) return;

      instance.items
        .map((item) => {
          const { top, height } = item.li.getBoundingClientRect();
          const distanceFromCenterOfScreen = Math.abs(
            window.innerHeight / 2 - (top + height / 2),
          );

          return { item, distanceFromCenterOfScreen };
        })
        .toSorted((a, b) => {
          return a.distanceFromCenterOfScreen < b.distanceFromCenterOfScreen
            ? -1
            : 1;
        })
        .forEach((item, idx) => toggle(item.item.button, idx === 0));
    });
  }

  openTheItemClosestToTheCenter();

  const teardown = lenis.on("scroll", openTheItemClosestToTheCenter);

  return teardown
};
